import { graphql, useStaticQuery } from 'gatsby';
import { MenuData } from 'lib/types';

export type RootQuery = {
    nav: MenuData;
    footer: MenuData;
    expertsPage: {
        pageData: {
            showPage: boolean;
        };
    };
};

const EXPERTS_PATH = '/experts';

const query = graphql`
    fragment NavData on MenuItem {
        id
        external
        to
        label
        boldLabel
        sortOrder
    }
    query pageNav {
        nav: menu(slug: { eq: "nav" }) {
            items {
                ...NavData
                subItems {
                    ...NavData
                }
            }
        }
        footer: menu(slug: { eq: "footer" }) {
            items {
                ...NavData
                subItems {
                    ...NavData
                }
            }
        }
        expertsPage: page(slug: { eq: "experts" }) {
            pageData
        }
    }
`;

export default function useNavData(): Omit<RootQuery, 'expertsPage'> {
    const { footer, nav, expertsPage } = useStaticQuery<RootQuery>(query);

    if (expertsPage?.pageData?.showPage) {
        return {
            footer,
            nav,
        };
    }

    const newNav = {
        ...nav,
        items: nav.items.map((item) => {
            return {
                ...item,
                subItems: item.subItems?.filter(
                    ({ to }) => !to.endsWith(EXPERTS_PATH),
                ),
            };
        }),
    };
    return {
        footer,
        nav: newNav,
    };
}
